// import components
import { DataGrid as CustomDataGrid } from 'components/shared/DataGrid';

// import hooks
import { useTranslation } from 'react-i18next';

// import types
import type { GridColDef } from '@mui/x-data-grid-pro';
import type { ExcelFinding } from '../../ExcelImport.types';
import type { ExcelImportFindingsProps } from './ExcelImportFindings.types';

const ExcelImportFindings = ({ findings }: ExcelImportFindingsProps) => {
  'use memo';
  const { t } = useTranslation();

  const columns: GridColDef<ExcelFinding & { id: number }>[] = [
    {
      field: 'rowNumber',
      headerName: t('adminPortal.servicedesk.excelImport.findings.rowNumber'),
      flex: 1
    },
    {
      field: 'column',
      headerName: t('adminPortal.servicedesk.excelImport.findings.column'),
      flex: 1
    },
    {
      field: 'expected',
      headerName: t('adminPortal.servicedesk.excelImport.findings.expected'),
      flex: 1
    },
    {
      field: 'found',
      headerName: t('adminPortal.servicedesk.excelImport.findings.found'),
      flex: 1
    }
  ];

  const rows = findings.map((finding, index) => ({ id: index, ...finding }));

  return (
    <CustomDataGrid
      title={t('adminPortal.servicedesk.excelImport.findings.title')}
      rows={rows}
      columns={columns}
      disableActions
      dynamicHeight
    />
  );
};

export default ExcelImportFindings;
